module.exports = __webpack_public_path__ + "static/wahCube-5051689813193dd35be1768bbcefb897.jpg";